/**
 * Route for `creative-preview-url`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CreativePreviewUrlPage } from "../features/creative-preview-url/CreativePreviewUrlPage";

export const creativePreviewUrlRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/creative-preview-url",
	component: CreativePreviewUrlPage,
});

export default creativePreviewUrlRoute;
